import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';
import { permissionGuard } from '../../core/guards/permission.guard';
import { operatorRoutes } from './pages/operators/operators.route';

export const settingsRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'parkings',
    pathMatch: 'full',
  },
  {
    path: 'parkings',
    loadComponent: () => import('../object-management/pages').then(p => p.ParkingListPage),
    title: 'UIMS - Parkings',
    canActivate: [permissionGuard('parking-lots:view')],
  },
  {
    path: 'parkings/create',
    loadComponent: () => import('../object-management/pages').then(p => p.ParkingCreatePage),
    title: 'UIMS - Parking Create',
    canActivate: [permissionGuard('parking-lots:view')],
  },
  {
    path: 'parkings/:id',
    loadComponent: () => import('../object-management/pages').then(p => p.ParkingsDetailsComponent),
    title: 'UIMS - Parking Details',
    canActivate: [permissionGuard('parking-lots:view')],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'posts',
    loadComponent: () => import('../object-management/pages').then(p => p.PostListPage),
    title: 'UIMS - Posts',
    canActivate: [permissionGuard('posts:view')],
  },
  {
    path: 'posts/create',
    loadComponent: () => import('../object-management/pages').then(p => p.PostsCreatePage),
    title: 'UIMS - Post Create',
    canActivate: [permissionGuard('posts:view')],
  },
  {
    path: 'posts/:id',
    loadComponent: () => import('../object-management/pages').then(p => p.PostsDetailsComponent),
    title: 'UIMS - Post Details',
    canActivate: [permissionGuard('posts:view')],
  },
  {
    path: 'gates',
    loadComponent: () => import('../object-management/pages').then(p => p.GateListPage),
    title: 'UIMS - Gates',
    canActivate: [permissionGuard('lanes:view')],
  },
  {
    path: 'gates/create',
    loadComponent: () => import('../object-management/pages').then(p => p.GatesCreatePage),
    title: 'UIMS - Gates Create',
    canActivate: [permissionGuard('lanes:view')],
  },
  {
    path: 'gates/:id',
    loadComponent: () => import('../object-management/pages').then(p => p.GatesDetailsComponent),
    title: 'UIMS - Gates Details',
    canActivate: [permissionGuard('lanes:view')],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'cameras',
    loadComponent: () => import('../object-management/pages').then(p => p.CamerasListPage),
    title: 'UIMS - Cameras',
    canActivate: [permissionGuard('cameras:view')],
  },
  {
    path: 'cameras/create',
    loadComponent: () => import('../object-management/pages').then(p => p.CameraCreateComponent),
    title: 'UIMS - Camera Create',
    canActivate: [permissionGuard('cameras:view')],
  },
  {
    path: 'cameras/:id',
    loadComponent: () => import('../object-management/pages').then(p => p.CameraDetailsComponent),
    title: 'UIMS - Camera Details',
    canActivate: [permissionGuard('cameras:view')],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'devices',
    loadComponent: () => import('../object-management/pages').then(p => p.DevicesListPage),
    title: 'UIMS - Devices',
    canActivate: [permissionGuard('devices:view')],
  },
  {
    path: 'devices/create',
    loadComponent: () => import('../object-management/pages').then(p => p.DeviceWizardComponent),
    title: 'UIMS - Device Connect',
    canActivate: [permissionGuard('devices:view')],
  },
  {
    path: 'devices/:id',
    loadComponent: () => import('../object-management/pages').then(p => p.DeviceDetailsComponent),
    title: 'UIMS - Device Details',
    canActivate: [permissionGuard('devices:view')],
  },
  {
    // Схема объекта (OS5–OS7): конструктор топологии. Доступ — ВСЕ четыре view-права (AND):
    // OPERATOR имеет lanes/cameras:view, но не posts/devices:view (TECHNICAL_STAFF-only).
    path: 'schema',
    loadComponent: () => import('../object-management/pages').then(p => p.SchemaPage),
    title: 'UIMS - Object Schema',
    canActivate: [
      permissionGuard('posts:view'),
      permissionGuard('devices:view'),
      permissionGuard('lanes:view'),
      permissionGuard('cameras:view'),
    ],
  },
  {
    path: 'operators',
    loadComponent: () => import('./pages').then(p => p.OperatorsPage),
    title: 'UIMS - Operators',
    children: operatorRoutes,
  },
];
